import { EmptyContent } from '@/components/common/empty-content'
import { BlogCategories } from '@/features/blogs/components/BlogCategories'
import { Box, Grid, Skeleton, Stack } from '@mui/material'
import HTMLReactParser from 'html-react-parser/lib/index'
import { TCommonContent } from '../types'

export const CommonContent = ({
  data: convertedData,
  isLoading,
}: {
  data: TCommonContent | undefined
  isLoading?: boolean
}) => {

  if (isLoading) return <Loading />
  if (!convertedData) {
    return <EmptyContent title="Chưa có nội dung" />
  }
  return (
    <Grid container spacing={2} columns={9}>
      <Grid size={{ xs: 9, xl: 6 }}>
        <Box className="common-content">
          {HTMLReactParser(convertedData?.post_content || '')}
        </Box>
      </Grid>
      {/* <Grid size={{ xs: 9, xl: 3 }} display={{ xs: 'none', xl: 'block' }}> */}
        {/* <Box sx={{ position: 'sticky', top: '32px' }}> */}
          <BlogCategories gridProps={{size: { xs: 9, xl: 3 }, display: { xs: 'none', xl: 'block' }}} content={convertedData?.post_content} sx={{p: {xs: "0", lg: "1rem"}}}/>
        {/* </Box> */}
      {/* </Grid> */}
    </Grid>
  )
}

const Loading = () => {
  return (
    <Stack spacing={2}>
      <Box sx={{ width: '100%', flex: 1 }}>
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton width="60%" />
      </Box>
      <Stack spacing={{ xs: 1, md: 2 }} direction={'row'} sx={{ width: '100%', flex: 1 }}>
        <Skeleton sx={{ width: '100%', flex: 1 }} variant="rectangular" width={210} height={210} />
        <Skeleton sx={{ width: '100%', flex: 1 }} variant="rectangular" width={210} height={210} />
        <Skeleton sx={{ width: '100%', flex: 1 }} variant="rectangular" width={210} height={210} />
      </Stack>
      <Box sx={{ width: '100%', flex: 1 }}>
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton />
        <Skeleton width="60%" />
      </Box>
    </Stack>
  )
}
